import { ApiGeoUnit } from '@ibe/api';

export enum DestinationItemCategory {
  GEO_UNIT = 'GEO_UNIT',
  PRODUCT = 'PRODUCT',
  UNSET = 'UNSET'
}

export const isDestination = (
  item: ApiGeoUnit | DestinationItem | undefined
): item is DestinationItem => {
  // eslint-disable-next-line
  return !!item && item.hasOwnProperty('category');
};

interface DestinationItem {
  id: string;
  code: string;
  name: string;
  typeCode: string;
  category: DestinationItemCategory;
  parentId?: string;
}

export default DestinationItem;
